import styled from 'styled-components';
import { Box } from 'src/viewLayer/components/DesignSystem';

export const FootnoteContainer = styled(Box)`
  width: 18.75rem;
`;
